import { Container, Grid, Typography, Card, CardMedia, Dialog, DialogContent, IconButton, Box } from "@mui/material";
import SectionTitle from "../ui/SectionTitle";
import { useState } from "react";
import { appTheme } from "../../theme";
import AnimatedSection from "../animations/AnimatedSection";
import CloseIcon from "@mui/icons-material/Close";

// Импортируем все изображения для статической загрузки
import catteryNameFiFeCertificate from "../../images/diploms/Cattery Name FiFe Certificate.jpg";
import catteryNameWcfCertificate from "../../images/diploms/Cattery Name WCF Certificate.jpg";
import certificateGeneticsCatsAndFel from "../../images/diploms/Certificate Genetics Cats and Felinology.jpg";
import imgNews3 from "../../images/diploms/ImgNews3.jpg";
import nominatedBestInShow from "../../images/diploms/Nominated best in show.jpg";
import diploma254 from "../../images/diploms/diploma_254.jpg";
import diploma26 from "../../images/diploms/diploma_26.jpg";
import diploma29 from "../../images/diploms/diploma_29.jpg";
import diploma32 from "../../images/diploms/diploma_32.jpg";
import diploma33 from "../../images/diploms/diploma_33.jpg";
import diploma38 from "../../images/diploms/diploma_38.jpg";
import diploma52 from "../../images/diploms/diploma_52.jpg";
import diploma6 from "../../images/diploms/diploma_6.jpg";
import judgesReport from "../../images/diploms/judges report.jpg";
import diploma2021 from "../../images/diploms/diploma_1.jpg";
import diplomaSouthernStar from "../../images/diploms/diploma_2.jpg";
import diploma1718 from "../../images/diploms/diploma_3.jpg";

// Массив объектов с дипломами и их метаданными
const diploms = [
    { src: catteryNameFiFeCertificate, alt: "Сертификат FiFe питомника" },
    { src: catteryNameWcfCertificate, alt: "Сертификат WCF питомника" },
    { src: certificateGeneticsCatsAndFel, alt: "Сертификат по генетике кошек и фелинологии" },
    { src: imgNews3, alt: "Фото с мероприятия" },
    { src: nominatedBestInShow, alt: "Номинация Лучший в шоу" },
    { src: diploma254, alt: "Диплом №254" },
    { src: diploma26, alt: "Диплом №26" },
    { src: diploma29, alt: "Диплом №29" },
    { src: diploma32, alt: "Диплом №32" },
    { src: diploma33, alt: "Диплом №33" },
    { src: diploma38, alt: "Диплом №38" },
    { src: diploma52, alt: "Диплом №52" },
    { src: diploma6, alt: "Диплом №6" },
    { src: judgesReport, alt: "Отчёт судей" },
    { src: diploma2021, alt: "Диплом от 20-21.12.2014" },
    { src: diplomaSouthernStar, alt: "Диплом Южная звезда" },
    { src: diploma1718, alt: "Диплом от 17-18.05.2014" },
];

export default function AboutPage() {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState<typeof diploms[0] | null>(null);

    const openDialog = (image: typeof diploms[0]) => {
        setSelectedImage(image);
        setDialogOpen(true);
    };

    const closeDialog = () => {
        setDialogOpen(false);
        setSelectedImage(null);
    };

    return (
        <Container sx={{ pt: { xs: 12, md: 10 }, pb: 8 }}>
            <AnimatedSection delay={100}>
                <Box sx={{ height: { xs: 72, md: 80 } }} />
                <SectionTitle>О питомнике</SectionTitle>
            </AnimatedSection>

            <AnimatedSection delay={300}>
                <Typography variant="body1" sx={{ mt: 4, textAlign: "center", maxWidth: "800px", mx: "auto" }}>
                    Наш питомник занимается разведением элитных кошек с безупречной родословной. Мы гордимся высокими стандартами ухода,
                    профессиональным подходом к разведению и международными признаниями.
                </Typography>
            </AnimatedSection>

            <AnimatedSection delay={500}>
                <Typography variant="h4" sx={{ mt: 6, mb: 3, textAlign: "center" }}>
                    Наши достижения
                </Typography>
            </AnimatedSection>

            <Grid container spacing={3} justifyContent="center">
                {diploms.map((diplom, index) => (
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                        <AnimatedSection delay={700 + index * 100}>
                            <Card
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    transition: "transform 0.3s, box-shadow 0.3s",
                                    '&:hover': {
                                        transform: "scale(1.03)",
                                        boxShadow: appTheme.shadows[8],
                                    },
                                }}
                            >
                                <CardMedia
                                    component="img"
                                    image={diplom.src}
                                    alt={diplom.alt}
                                    sx={{
                                        height: 200,
                                        objectFit: "cover",
                                        cursor: "pointer",
                                        transition: "transform 0.3s ease",
                                        '&:hover': {
                                            transform: "scale(1.05)",
                                        },
                                    }}
                                    onClick={() => openDialog(diplom)}
                                />
                                {/* <CardContent>
                                    <Typography variant="body2" color="text.secondary" textAlign="center">
                                        {diplom.alt}
                                    </Typography>
                                </CardContent> */}
                            </Card>
                        </AnimatedSection>
                    </Grid>
                ))}
            </Grid>

            {/* Модальное окно для просмотра изображения */}
            <Dialog
                open={dialogOpen}
                onClose={closeDialog}
                maxWidth={false}
                fullWidth
                PaperProps={{
                    sx: {
                        maxWidth: "95vw",
                        maxHeight: "95vh",
                        bgcolor: "rgba(0,0,0,0.92)",
                        boxShadow: "none",
                    },
                }}
                slotProps={{
                    backdrop: { sx: { bgcolor: "rgba(0,0,0,0.9)" } },
                }}
            >
                <DialogContent
                    sx={{
                        p: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        minHeight: { xs: 280, sm: 400 },
                    }}
                >
                    <IconButton
                        aria-label="закрыть"
                        onClick={closeDialog}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            zIndex: 2,
                            color: "common.white",
                            bgcolor: "rgba(255,255,255,0.1)",
                            "&:hover": { bgcolor: "rgba(255,255,255,0.2)" },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    {selectedImage && (
                        <Box
                            component="img"
                            src={selectedImage.src}
                            alt={selectedImage.alt}
                            sx={{
                                maxWidth: "100%",
                                maxHeight: "90vh",
                                objectFit: "contain",
                                borderRadius: 1,
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </Container>
    );
}
